module.exports = {
  redirectURL (redirect, times) {
    if (!times) {
      times = 1
    }
    for (let i = 0; i < times; i++) {
      redirect = encodeURIComponent(redirect)
    }
    const url = location.protocol + '//' + location.host + '/user/auth-redirect.html?redirect=' + redirect
    return url
  }
}


// WEBPACK FOOTER //
// ./src/mods/auth.js